

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Bando } from "src/app/models/bando.model";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { Oda } from "src/app/models/oda.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";
import { OdaService } from "src/app/services/oda.service";


@Component({
  templateUrl: "./dialog-crea-oda.component.html",
  styleUrls: ["../oda.component.css"],
  providers: [MessageService]
})
export class CreaOdaComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  protected aziende: Impresa[]              = [];
  protected aziendeConOdaAttivo: Impresa[]  = [];
  protected bandi:Bando[];
  protected lotti:String[];

  public creaOdaForm: FormGroup;

  
  protected isCreatingOda:Boolean = false;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private odaService:OdaService,
  ) {
    
    this.creaOdaForm = this._formBuilder.group({
      azienda:                    [null, [Validators.required]],
      bando:                      new FormControl({value: null, disabled: true}, Validators.required),
      lotti:                      new FormControl({value: null, disabled: true}, Validators.required),
      referenteTim:               ['Daniele Gentile', [Validators.required]],
      numero:                     [null, [Validators.required]],
      importo:                    [null, [Validators.required]]
    });

    this.loadAziende();
  }

  ngOnInit(): void {
    
    
  }

  loadAziende(){
      this.logger.info("LOADING AZIENDE");
      this.impreseService.get().subscribe( {
          next: (res) => {
            this.aziende = res/* .filter(azienda => 
              !this.aziendeConOdaAttivo.some(aziendaConListino => aziendaConListino.id === azienda.id));
              this.logger.info(this.aziende) */;
          },
          error: (e) => {
            this.logger.info(e);
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di caricamento aziende'});
        },
          complete: () => {
          }
      });
  }

  onAziendaSelection(event){
    this.bandi = this.creaOdaForm.value.azienda.bandi;
    this.creaOdaForm.get("bando").enable();
  }

  onBandoSelection(event){
    this.logger.info( this.creaOdaForm.value.bando);

    if(this.creaOdaForm.value.bando.denominazione ==='BANDO 1'){
      this.lotti = ['6','7'];
    }else{
      this.lotti = ['1','5','7','8'];
    }
    
    this.creaOdaForm.get("lotti").enable();
  }

  checkNumero(event){
    this.odaService.checkNumero(this.creaOdaForm.value.numero).subscribe( {
      next: (ressCheckNumero) => {
        if(ressCheckNumero){
          this.messageService.add({ severity: 'warn', summary: 'ATTENZIONE', detail: 'Il numero indicato è già presente a sistema' });
          this.creaOdaForm.controls['numero'].setErrors({ 'duplicato': true });
          } else {
              // Rimuovi eventuali errori precedenti (se il numero non è duplicato)
              this.creaOdaForm.controls['numero'].setErrors(null);
          }
      },
      error: (e) => {
          this.isCreatingOda = false;
          this.logger.error(e);
          this.dialogRef.close({ success: false });
          this.messageService.add({
            severity: "error",
            summary: "ATTENZIONE",
            detail: "Errore in fase di check numero ODA!", life:10000
          });
      },
      complete: () => {

      }
    });
  }
  
  

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isCreatingOda = true;
      let oda:Oda = new Oda();
        oda.numero              = this.creaOdaForm.value.numero;
        oda.azienda             = this.creaOdaForm.value.azienda;
        oda.importo             = this.creaOdaForm.value.importo;
        oda.bando               = this.creaOdaForm.value.bando;
        oda.lotti               = this.creaOdaForm.value.lotti.join(",");
        oda.referenteTim        = this.creaOdaForm.value.referenteTim;
        oda.azienda             = this.creaOdaForm.value.azienda;
        this.logger.info(JSON.stringify(oda.lotti));
        this.odaService.crea(oda).subscribe( {
            next: (resCreaOda) => {
              this.isCreatingOda = false;
              this.dialogRef.close({ success: true });
            },
            error: (e) => {
                this.isCreatingOda = false;
                this.logger.error(e);
                this.dialogRef.close({ success: false });
                this.messageService.add({
                  severity: "error",
                  summary: "ATTENZIONE",
                  detail: "Errore in fase di creazione di un nuovo oda!", life:10000
                });
            },
            complete: () => {

            }
        });  
    }
  }
}
